/* eslint-disable import/no-cycle */
import {
  WidgetTypeConfig,
  ConfigurationPanelStructureItemEnum,
  ComponentNameEnum,
  ElementPartTypeEnum,
  TemplateStructureEnum,
} from '@/types';
import getWysiwygEditorFieldConfig from '@/components/template-builder/config/fields/wysiwyg-editor-config';
import variables from '@/components/template-builder/utils/variables-list';
import { i18n } from '@/i18n';
// eslint-disable-next-line import/no-cycle
import {
  setContent,
  setCssProperty,
  setCssPropertyAndRemoveIfZero,
} from '@/components/template-builder/setters';
// eslint-disable-next-line import/no-cycle
import {
  getContent,
  getCssPropertyByName,
} from '@/components/template-builder/getters';
// eslint-disable-next-line import/no-cycle
import { getDisclosureChannels } from '@/components/template-builder/getters/form';
// eslint-disable-next-line import/no-cycle
import { setDisclosureChannels } from '@/components/template-builder/setters/form';
// eslint-disable-next-line import/no-cycle
import { hasEmailWidgetInFunnel, hasPhoneWidgetInFunnel } from '@/composables/template-editor/TemplateEditor';
import bordersFieldConfig from '@/components/template-builder/config/fields/borders-config';
// eslint-disable-next-line import/no-cycle
import getConditionsAndRepetitionGroup from '@/components/template-builder/config/fields/conditions-repetition-group-helper';
import getWidgetCommonStylesGroup from '@/components/template-builder/config/fields/widget-common-styles-config';

const getDefaultDisclosureContent = () => (i18n.global as any).t('templateBuilder.fields.disclosureDefaultMessages.email');

const widgetDisclosureConfigV4: WidgetTypeConfig = {
  tabPanel: {
    label: 'templateBuilder.widgetsHeaders.disclosure',
    items: [
      {
        type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
        label: 'templateBuilder.configs.widgetConfiguration',
        selector: 'body #spm_body #{ID}',
        items: [
          {
            label: 'templateBuilder.fields.disclosureChannels',
            selector: '{SELECTOR}',
            properties: [{
              name: 'data-disclosure-channels',
              getter: getDisclosureChannels,
              setters: [setDisclosureChannels],
            }],
            componentName: ComponentNameEnum.MULTIDROPDOWN,
            options: {
              defaultValue: [],
              list: [
                { value: 'email', label: 'Email' },
                { value: 'sms', label: 'SMS' },
                { value: 'whatsapp', label: 'WhatsApp' },
              ],
              isOptionDisabled: (value: string): boolean => {
                if (value === 'email') return !hasEmailWidgetInFunnel();
                if (value === 'sms' || value === 'whatsapp') return !hasPhoneWidgetInFunnel();
                return false;
              },
            },
          },
          {
            label: 'templateBuilder.fields.wysiwygEditor',
            selector: '{SELECTOR}.spm_widget_disclosure > div.spm_rich_editor',
            properties: [{ name: 'content', getter: getContent, setters: [setContent] }],
            ...getWysiwygEditorFieldConfig(getDefaultDisclosureContent(), variables.allVariables),
          },
        ],
      },
      {
        type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
        tabItemType: TemplateStructureEnum.GROUP,
        label: 'templateBuilder.configs.widgetStyles',
        canSave: true,
        elementPartType: ElementPartTypeEnum.STYLES,
        tabPanel: {
          items: [
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.widgetBlockStyles',
              selector: 'body #spm_body #{ID}',
              items: [
                {
                  label: 'templateBuilder.fields.borders',
                  selector: '{SELECTOR}',
                  properties: [
                    { name: 'border-color', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-style', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-width', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
                    { name: 'border-bottom-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-bottom-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-bottom-width', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-top-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-top-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-top-width', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-left-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-left-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-left-width', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-right-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-right-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-right-width', getter: getCssPropertyByName, setters: [] },
                  ],
                  ...bordersFieldConfig,
                },
              ],
            },
            getWidgetCommonStylesGroup(),
          ],
        },
      },
      getConditionsAndRepetitionGroup('body #spm_body #{ID}'),
    ],
  },
};

export default widgetDisclosureConfigV4;
